/**
 * Created by Hiroki Moto
 * Updated at 03/02/2020
 * https://marvelapp.com/43fgc52/screen/55854690
 */

import React, { memo } from 'react';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import Input from '@components/@core/Input';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Document from './Document';
import { getSettings } from '~/services/util';

function Detail(props) {
    const { type, document, authors, departments, competencies, categories, isAdmin, onChange } = props;
    const dropdownMenu = isAdmin
        ? [
              { id: 1, value: 'Assign' },
              { id: 3, value: 'Edit View' },
          ]
        : [{ id: 1, value: 'Assign' }];
    return (
        <>
            <Filter back={`all ${type}s`} />
            <div className="library-document-card border-5">
                <div className="detail-content">
                    <div className="d-flex jc-between py-1">
                        <p className="dsl-b22 bold mb-0">{document.name || document.title}</p>
                        <div className="edit">
                            <Dropdown align="right" data={dropdownMenu} caret="dots-without-title" returnBy="data" iconColor="#969faa" iconSize={16} onChange={onChange} />
                        </div>
                    </div>
                    <div className="py-2">
                        <p className="dsl-m12 mb-0">Description</p>
                        <div className="p-2">
                            <span className="dsl-b16 truncate-four">{document.data.description}</span>
                        </div>
                    </div>
                    {type === 'esign' ? (
                        <Row className="mx-0 mt-2">
                            <Col xs={12} sm={6} className="px-0">
                                <p className="dsl-m12 mb-0">Singers</p>
                                <div className="p-2">
                                    <p className="dsl-b16 mb-0">15</p>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} className="px-0">
                                <p className="dsl-m12 mb-0">Countersingers</p>
                                <div className="p-2">
                                    <p className="dsl-b16 mb-0">3</p>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <Row className="mx-0 mt-2">
                            <Col xs={12} sm={6} className="px-0">
                                <p className="dsl-m12 mb-0">File</p>
                                <div className="p-2">
                                    <p className="dsl-b16 mb-0">
                                        <a className="dsl-b16 text-primary word-break" href={document.data.attachment} target="_blank">
                                            {document.data.file}
                                        </a>
                                    </p>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} className="px-0">
                                <p className="dsl-m12 mb-0">Last time Changed</p>
                                <div className="p-2">
                                    <p className="dsl-b16 mb-0">{moment.utc(document.updated_at).local().format('MMM DD, YYYY')}</p>
                                </div>
                            </Col>
                        </Row>
                    )}

                    <Accordion className="settings" icon={null}>
                        <Row className="mt-1">
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Author" direction="vertical" value={getSettings([document.author_id], authors, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Departments" direction="vertical" value={getSettings(document.data.department, departments, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Competencies" direction="vertical" value={getSettings(document.data.competency, competencies, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Categories" direction="vertical" value={getSettings(document.data.category, categories, 'N/A')} />
                            </Col>
                        </Row>
                    </Accordion>
                </div>
            </div>
            {type == 'packets' && (
                <div className="library-document-card border-5 mt-3 py-3">
                    <div className="d-flex justify-content-between">
                        <span className="dsl-b20 bold mb-0">Documents</span>
                        <Button type="link">
                            <Icon name="fas fa-plus" size={12} color="#376caf" />
                            <span className="dsl-p14 ms-1">Add Document</span>
                        </Button>
                    </div>
                    <Document
                        name="New Hire Orientation"
                        description="Lorem Ipsum is simply dummy text"
                        iconName="fas fa-file-pdf"
                        documentName="PDF"
                        modules={5}
                        attachments="https://www.google.com"
                        updatedAt="2020-03-02 10:10:10"
                        onShow={() => {}}
                        onToggle={() => {}}
                        onChange={() => {}}
                    />
                </div>
            )}
        </>
    );
}

export default memo(Detail);
